import classNames from 'classnames'
import styles from './styles.module.scss'
import { OrderStatusProps } from '../../helpers/getOrderStatus'

export function OrderItemHeader({
  name,
  children,
  status,
  label
}: {
  name: string
  children: React.ReactNode
  status: OrderStatusProps['status']
  label: string
}) {
  const statusNameClasses = classNames(styles.OrderItemHeader__statusName, {
    [styles.OrderItemHeader__statusName__success]:
      status === 'In Transit' || status === 'Refunded' || status === 'Delivered',
    [styles.OrderItemHeader__statusName__error]:
      status === 'Oops' || status === 'Cancelled'
  })
  return (
    <div className={styles.OrderItemHeader}>
      <div className={styles.OrderItemHeader__orderName}>
        <strong>{name}</strong>
      </div>
      <div className={styles.OrderItemHeader__status}>
        <span className={statusNameClasses}>{status}</span>: {label}
      </div>
      <div className={styles.OrderItemHeader__side}>{children}</div>
    </div>
  )
}
